import { Modal } from 'antd';
import React from 'react';

const UpcomingBirthdaysModal = ({ visible, onClose, upcomingBirthdays }) => {
  return (
    <Modal
      title="Upcoming Birthdays"
      visible={visible}
      onCancel={onClose}
      footer={null}
    >
      {upcomingBirthdays && upcomingBirthdays.length > 0 ? (
        <ul>
          {upcomingBirthdays.map((user) => {
            const birthAnniversary = new Date(user.birthAnniversary);
            const formattedBirthdate = birthAnniversary.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });

            return (
              <li key={user.id}>
                {user.firstName} {user.lastName} - {formattedBirthdate}
              </li>
            );
          })}
        </ul>
      ) : (
        <p>No upcoming birthdays in the next 30 days.</p>
      )}
    </Modal>
  );
};

export default UpcomingBirthdaysModal;
